var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaf({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_514_2133",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 19,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3332 9.36558C17.3315 10.7629 16.8583 12.1187 15.9902 13.2136C14.9923 14.4717 13.5419 15.2897 11.949 15.4928C10.3561 15.6959 8.74685 15.2681 7.46518 14.3006L12.2562 9.51158L11.0682 8.31958L6.26818 13.1196L6.22618 13.0666C5.42712 11.9982 4.99369 10.7007 4.99018 9.36658C4.99282 7.73258 5.64289 6.16623 6.79801 5.01054C7.95314 3.85485 9.51918 3.20402 11.1532 3.20058H17.3332V9.36558ZM11.1522 1.51758C9.07175 1.52049 7.07743 2.3485 5.60673 3.81996C4.13602 5.29141 3.30903 7.28615 3.30718 9.36658C3.31083 11.064 3.86176 12.7151 4.87818 14.0746C4.87818 14.0746 4.95118 14.1746 5.07118 14.3156L1.05518 18.3296L2.24318 19.5176L6.26418 15.5006L6.27818 15.5126C7.66499 16.6237 9.39013 17.2271 11.1672 17.2226C12.3476 17.2257 13.5134 16.9608 14.5767 16.4479C15.6399 15.935 16.5728 15.1874 17.3052 14.2616C18.4094 12.8692 19.0112 11.1447 19.0132 9.36758V1.51758H11.1522Z",
    fill: "#282B3E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_514_2133)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    fill: "#00A758"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/Leaf.7cef071d54f123a523f4eafec82fa769.svg";
export { ForwardRef as ReactComponent };